import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { trackError } from '../tracking';

const BASE_URL = runtimeConfig.apiUrl;

const onRequest = (request: AxiosRequestConfig) => {
  const token = localStorage.getItem('access_token');
  if (token && request.headers) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  return Promise.resolve(request);
};

const onResponse = (response: AxiosResponse) => {
  return Promise.resolve(response);
};

const onResponseError = (error: any) => {
  const errorStatus = error.response?.status;
  if (error) {
    trackError(error, errorStatus);
  }
  return Promise.reject(error);
};

const baseApiClient: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

baseApiClient.interceptors.request.use(onRequest);
baseApiClient.interceptors.response.use(onResponse, onResponseError);

export { baseApiClient };
